// Capture receipt before the user spends time in the lobby. Monotonic time is
// independent of the participant's timezone and manual device clock changes.
export function stampMeetingClock(response) {
    const data = response?.data || response;
    const tokens = data?.tokens || data;
    if (tokens?.session_started_at && tokens?.server_time) {
        tokens.clock_received_at = performance.now();
    }
    return response;
}
